export default {
  title: 'فرم مدیر',
  detail: 'ایجاد و ویرایش  اطلاعات مدیر',
  mobile : 'شماره موبایل',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  lastName : 'نام',
  firstName : 'نام خانوادگی',
  back : 'لغو',
  success : 'موفق',
  error : 'خطا',
  save : 'ذخیره',
  loading : 'در حال بارگزاری',
  saving : 'در حال بارگزاری ...',
  placeholderMobile:'شماره موبایل را وارد نماید',
  placeholderFirstName:'نام را وارد نماید',
  placeholderLastName:'نام خانوادگی را وارد نماید',
}
